import { Box, Button, Dialog } from "@mui/material";
import { env } from "../../../../core/Env"
import { rqx } from "../../../../core/request/API"
import Cafgu from '../../../../assets/images/core/cafgu.png';

const apiBase = () => `<<global>>/${env() === 'local' ? 'dev' : env()}`

export const ReadPersonalization = async ({user_id, ref}) => {
    try{
        return await rqx.get(`${apiBase()}/personalization/read`, {tool_id: process.env.REACT_APP_TID_PSL, user_id: user_id, ref: ref})
    }catch (error){
        console.error("readPersonalization error:", error);
        throw error
    }
};   


export const PostPersonalization = async({body}) => {
    try{
        // sample body
        // let body = {
        //     user_id: parseInt(window.atob(ainfo.aid).split('_')[1]),
        //     feature_name: 'welcomepage',
        //     personalization:[
        //         {p_name: 'welcome', status: 1}, {p_name: 'onboarding' , status: 0}
        //     ]
        // }
        const res = await rqx.post(`${apiBase()}/personalization/create`, {tool_id: process.env.REACT_APP_TID_PSL, ...body})
        return res
    }catch (error){
        console.error("readPersonalization error:", error);
        throw error
    }
}

export const FeaturesWelcome = ({open, name, description, next}) => {
    return(
        <Dialog open={open} PaperProps={{ sx: { borderRadius: '16px' } }} >
           <Box maxWidth={{xs:'100%', sm:420}} display="flex" flexDirection="column" gap={2} p={3}>
                <Box display="flex" justifyContent="center">
                    <img src={Cafgu} alt="cafgu-img" width={200} height={200} />
                </Box>
                <Box textAlign="center">
                    <Box fontWeight="bold" fontSize={20}>Welcome to {name}!</Box>
                    <Box fontSize={14} color="#333333">{description}</Box>
                    <Box component={Button} variant="contained" mt="12px" onClick={next}>
                        Next
                    </Box>
                </Box>
             </Box>
        </Dialog>
    )
}